import React, { useState, useRef, useEffect } from "react"
import Header from "./header-results"
import Filters from "./filters"
import Results from "./results"
import HandlerBar from "./handler-bar"

import Seo from "../../components/seo"

import {getType,getOperationView, makeParamsGetByFilters, makeFormDataByFilters} from '../../helpers/helper.filters'
import { useLocation } from '@reach/router';
import Breadcrumbs from "../breadcrumbs";
import {
  getAllLocationsAction,
  redux_updateOrders,
} from "../../redux/propertiesDucks"
import Paginate from "../paginate"

import { connect } from "react-redux"

import { graphql, useStaticQuery } from "gatsby"
import SumaryFilters from "./sumary-filters"

const modules = [
  { name: "Filter", id: 1 },
  { name: "MultiView", id: 2 },
]

const wrapper = ({ api_key, allLocations, dispatch }) => {
  const { realEstate } = useStaticQuery(graphql`
    query {
      realEstate {
        template_version
        proFeatures {
          mapView
        }
      }
    }
  `)
  const { template_version, proFeatures } = realEstate
  const MediaPro = template_version === "PRO" ? true : false
  const { mapView } = proFeatures

  const [MapComponent, setComponent] = useState(null)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const importedComponent = require("./map-results")
      setComponent(importedComponent.default)
    }
  }, [])

  const [menu, setMenu] = useState(false)
  const [viewId, setViewId] = useState(mapView ? 0 : 2) // 0: list-map, 1: map, 2: grid
  // const [viewId,setViewId] = useState(2) // 0: list-map, 1: map, 2: grid

  useEffect(() => {
    var screenWidth = screen.width
    if (screenWidth < 992 && mapView) {
      setViewId(2)
    }
  }, [])

  return (
    <>
      <Filters menu={menu} setMenu={setMenu} />
      <div id="properties" class={" " + (viewId === 2 ? 'isGrid' : '') + (MediaPro && " Media-Pro-Section")}>
        <div className="container-fluid" style={{ zIndex: 99 }}>
          {!mapView && (
            <p
              onClick={() => setMenu(!menu)}
              id="openFilters"
              className="d-flex d-lg-none align-items-center justify-content-center"
            >
              <i className="icon-filters me-2"></i>
              <h4 className="mb-0">FILTRAR</h4>
            </p>
          )}
          <div className="row pb-lg-0 pb-2 fixed-desktop fixed-mobile">
            <HandlerBar
              setViewId={setViewId}
              viewId={viewId}
              setMenu={setMenu}
              menu={menu}
            />{" "}
            {/* {MediaPro - Filter} */}
          </div>
        </div>
        <div className="row pb-lg-0 pb-2 fixed-desktop fixed-mobile">
          <Header menu={menu} viewId={viewId} setMenu={setMenu} />
        </div>

        {viewId === 2 && (
          <div className="container-fluid">
            <div className="row">
              <Results viewId={viewId} menu={menu} setMenu={setMenu} />
              <Paginate />
            </div>
          </div>
        )}
        <div className={"second-view " + (viewId === 2 ? "zIndexDown" : "")}>
          {typeof window !== "undefined" && MapComponent ? (
            <MapComponent menu={menu} setMenu={setMenu} viewId={viewId} />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  )
}

export default connect(
  state => ({
    filters: state.properties.filters,
    totalCount: state.properties.totalCount,
    loading: state.properties.loading,
    filters: state.properties.filters,
}),null)(wrapper);
